import v2_getSpent_action from "src/actions/v2/cliente/v2.getSpent.action"


export const getSpent = async (clienteId, querys) => {
    try {

        const response = await v2_getSpent_action(clienteId, querys)
        if(response.status === 200) {
            return response.data
        }
    } catch(error) {
        console.log('erro ao transferir chat')
    }

}

